import React, { ReactElement } from 'react';
import { IAffiliationEvent, IAffiliationLocation, IAffiliationPlace, IStream } from "@common/redux/types/invoices";
import styles from './StreamsContent.module.scss';
import { getAddress } from "@kursk/utils/getAddress";
import { normalizePhone, prettifyPhone } from "@common/utils/phones";
import Link from "next/link";
import { TextBlock } from "@kursk/components/ui/ContentBlock/TextBlock/TextContent";
import { getComment } from "@kursk/utils/getComment";

interface IProps {
  entity: IStream;
}

export function StreamsContent({ entity }: IProps): ReactElement {

  const getPlaceLink = (affiliation: IAffiliationPlace) => {
    if (affiliation.place) {
      return <Link
        href={`/places/${affiliation?.place?._id}/${affiliation?.place?.sysName}`}>
        {affiliation?.place?.name}
      </Link>
    }
    return '';
  }

  const getEventLink = (affiliation: IAffiliationEvent) => {
    if (affiliation?.seance && affiliation?.seance?.venue?.location) {
      return getAddress(affiliation?.seance.venue.location.address)
        + getComment(affiliation?.seance.venue.location.address);
    }
    if (affiliation?.seance?.venue?.place) {
      return <Link
        href={`/places/${affiliation.seance.venue.place?._id}/${affiliation?.seance.venue.place?.sysName}`}>
        {affiliation?.seance.venue.place?.name}
      </Link>
    }
    return '';
  }

  const getLocationLink = (affiliation: IAffiliationLocation) => {
    if (affiliation?.location?.address) {
      return getAddress(affiliation?.location?.address)
        + getComment(affiliation?.location?.address);
    }
    return '';
  }

  return (
    <div className={styles.streams_wrapper}>
      <TextBlock text={entity.text}/>
      <div className={styles.streams_contacts}>
        <div className={styles.streams_address}>
          {entity.affiliation.type === 'place' && getPlaceLink(entity.affiliation)}
          {entity.affiliation.type === 'entity' && getEventLink(entity.affiliation)}
          {entity.affiliation.type === 'location' && getLocationLink(entity.affiliation)}
        </div>
        {!!entity?.contacts?.employeeName && (<div className={styles.streams_employee}>
          <div className={styles.streams_employee__title}>
            Организатор:
          </div>
          <div className={styles.streams_employee__name}>
            {entity.contacts.employeeName}
          </div>
        </div>)}
        {!!entity?.contacts?.employeePhone && (<div className={styles.streams_employee}>
          <div className={styles.streams_employee__title}>
            Телефон:
          </div>
          <div className={styles.streams_employee__name}>
            <a href={'tel:' + normalizePhone(entity.contacts.employeePhone)}>
              {prettifyPhone(entity.contacts.employeePhone)}
            </a>
          </div>
        </div>)}
        {!!entity?.contacts?.email && (<div className={styles.streams_employee}>
          <div className={styles.streams_employee__title}>
            Email:
          </div>
          <div className={styles.streams_employee__name}>
            <a href={'mailto:' + entity.contacts.email}>
              {entity.contacts.email}
            </a>
          </div>
        </div>)}
      </div>
    </div>
  );
}
